<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-6">
        <div class="content new-item">
          <h2 class="block-title" style="margin-bottom: 30px">{{ Label }}</h2>
          <el-form ref="form" label-position="top" :model="wordlist" :rules="rules" @submit.native.prevent>
            <el-form-item label="Name" prop="name">
              <el-input v-model="wordlist.name" placeholder="Enter something..."></el-input>
            </el-form-item>
            <div class="" style="width: 100%; display: inline-flex">
              <div class="d-form">
                <el-form-item class="form-group" label="Content" prop="data">
                  <el-input type="textarea" placeholder="" v-model="wordlist.data" style="font-size: 14px"></el-input>
                </el-form-item>
              </div>
              <div class="d-form" style="align-self: center">OR</div>
              <div class="d-form">
                <el-form-item label="Load content from file" class="form-group">
                  <div class="border-block">
                    <el-upload ref="upload" drag action :auto-upload="true" :file-list="fileList"
                      :before-upload="handleFileUpload" multiple>
                      <i class="vik vik-upload"></i>
                      <div class="el-upload__text">
                        Drop file here or <em>click to upload</em>
                      </div>
                      <div class="el-upload__tip" slot="tip">
                        txt files with a size less than 100mb
                      </div>
                    </el-upload>
                  </div>
                </el-form-item>
              </div>
            </div>
            <el-form-item>
              <el-button class="btn btn-success" @click="submitUpload" :loading="loading"
                icon="vik vik-save">Save</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus.js";
import * as utils from "@/utils.js";
import {
  editFile,
  getFile,
} from "@/api.js";
export default {
  data() {
    return {
      isNewFile: false,
      loading: false,
      file: null,
      fileList: [],
      wordlist: {
        name: "",
        data: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Name is required",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Must not be empty",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.params.hash == 'new') {
      this.isNewFile = true
    }
    if (!this.isNewFile)
      this.load()
  },
  computed: {
    Label() {
      return this.isNewFile ? "New file" : "Edit file";
    }
  },
  methods: {
    async load() {
      let that = this
      getFile(this.$route.params.hash).then((data) => {
        //this.files = data.Records;
        // this.total = data.Total;
        //this.filesLoading = false;
        that.wordlist.name = data.Records.file_name
        that.wordlist.data = data.Records.data
        console.log('data', data)
      });
    },
    handleFileUpload(file) {
      const that = this;
      this.file = file;
      this.file.text().then((data) => {
        that.wordlist.data += data;
      });
      return false;
    },
    submitUpload() {
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          that.loading = true;
          editFile({
            id: that.$route.params.hash,
            file_name: that.wordlist.name,
            data: that.wordlist.data
          })
            .then(() => {
              that.$notify({
                type: "success",
                title: "Success",
                message: "File created",
              });
              that.loading = false;
              that.$router.push({
                name: "StorageFiles",
              });
            })
            .catch((err) => {
              this.$notify.error({
                title: "Error",
                message: err.error,
              });
            });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/EditFile.vue